(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    	.controller('AutomationController', automation);

  automation.$inject = ['$scope', '$http', '$stateParams', '$location', 'Automacao'];

  function automation ($scope, $http, $stateParams, $location, Automacao) {
    	var vm = this;

    Automacao.all(function (data) {
      vm.emails = data;
    });

    vm.addEmail = function () {
      vm.emails.push({ email: '' });
    }

    vm.removeEmail = function (index) {
      vm.emails.splice(index, 1);
    }

    vm.save = function () {
      Automacao.save(vm.emails, function (data) {

      });
    }
  }
})();
